import React, { useContext, useEffect, useState } from "react"
import { Button, Col, Modal, Row } from "antd"
import { SessaoARContext } from "../../../Contexts/SessaoContext";
import { TypeAluno } from "../../../../Models/Domain/Pessoa/Aluno";
import { ParametrosDaSessaoARContext } from ".";
import { EnumTipoUsuario } from "../../../../Models/Domain/AreaRestrita/Sessao";
import { SelecaoDeAluno } from "../../../Components/SelecaoDeAluno";
import { GerenciadorDoLocalStorage } from "./GerenciadorDoLocalStorage";
import { TypeResponsavel } from "../../../../Models/Domain/Pessoa/Responsavel";
import { Navigate } from "react-router-dom";
import { NovoAlunoDoResponsavel } from "../../../Components/Acesso/NovoAlunoDoResponsavel";
import { CancelarSessaoERemoverToken } from "../Splash";

export type ParametrosDaSessaoDoResponsavel = {
    bloquearTrocaDeAlunos: boolean;
    setBloquearTrocaDeAlunos: React.Dispatch<React.SetStateAction<boolean>>

    tipoDeUsuario: EnumTipoUsuario.Responsavel;

    alunoSelecionado: TypeAluno | undefined,
    setExibirSelecaoDeAluno: React.Dispatch<React.SetStateAction<boolean>>
    setExibirNovoAluno: React.Dispatch<React.SetStateAction<boolean>>
}

export const ComParametrosDaSessaoDoResponsavel: React.FC<{
    children: React.ReactNode
}> = (props) => {

    const SessaoAR = useContext(SessaoARContext);

    const [alunoSelecionado, setAlunoSelecionado] = useState<TypeAluno | undefined>(
        (() => {
            if(SessaoAR?.sessao?.tipoDeUsuario != EnumTipoUsuario.Responsavel) return undefined;
            const v = GerenciadorDoLocalStorage.get<number | undefined>(GerenciadorDoLocalStorage.chaves.alunoSelecionado);
            if(v == undefined) return;

            return SessaoAR?.sessao?.info?.alunos?.find((a) => a.aluno.codigo == v.valor)?.aluno;
        })()
    )

    const [exibirNovoAluno, setExibirNovoAluno] = useState<boolean>(false)
    const [exibirSelecaoDeAluno, setExibirSelecaoDeAluno] = useState<boolean>(false)
    const [bloquearTrocaDeAlunos, setBloquearTrocaDeAlunos] = useState<boolean>(false)

    useEffect(() => {
        GerenciadorDoLocalStorage.set<number | undefined>(GerenciadorDoLocalStorage.chaves.alunoSelecionado, alunoSelecionado?.codigo)
    }, [alunoSelecionado])

    useEffect(() => () => { GerenciadorDoLocalStorage.clear() }, [])

    const parametros: ParametrosDaSessaoDoResponsavel = {
        tipoDeUsuario: EnumTipoUsuario.Responsavel,
        bloquearTrocaDeAlunos, setBloquearTrocaDeAlunos,
        alunoSelecionado,
        setExibirSelecaoDeAluno,
        setExibirNovoAluno
    };

    //const responsavel = (SessaoAR?.sessao?.info) as TypeResponsavel
    // const possuiAlgumAluno = responsavel.alunos ? responsavel.alunos.length > 0 : false;

    return <React.Fragment>

        <ParametrosDaSessaoARContext.Provider value={parametros}>
            {/* {
                possuiAlgumAluno ? */}
                    <React.Fragment>
                        {/* <Modal
                            destroyOnClose
                            title="Selecione um aluno para continuar"
                            open={alunoSelecionado == undefined || exibirSelecaoDeAluno == true}
                            width={"80vw"}
                            maskClosable={false}
                            footer={null}
                            onCancel={() => {
                                setExibirSelecaoDeAluno(false)
                            }}
                        >
                            <SelecaoDeAluno.ParaResponsavel
                                aoSelecionar={(aluno) => {
                                    setAlunoSelecionado(aluno);
                                    setExibirSelecaoDeAluno(false);
                                }}
                                style={{ marginTop: "1em" }}
                            />
                        </Modal> */}

                        {/* 
                        Remover opção de cadastrar novo aluno 
                        <Modal
                            title={<> Novo aluno </>}
                            width={"80vw"}
                            open={exibirNovoAluno}
                            footer={null}
                            closable={true}
                            onCancel={() => setExibirNovoAluno(false)}
                        >
                            <NovoAlunoDoResponsavel
                                depoisDeFinalizar={(aluno, viagem) => {
                                    setAlunoSelecionado(aluno);
                                    window.location.reload();
                                }}
                            />
                        </Modal> */}
                    </React.Fragment>
                    {/* :
                    <Modal
                        title={<>
                            <Row>
                                <Col xs={24} style={{ display: "flex", flexDirection: "row-reverse" }}>
                                    <Button type="link" onClick={() => {
                                        CancelarSessaoERemoverToken(SessaoAR?.setSessao)
                                    }} >Sair</Button>
                                </Col>
                            </Row>

                            Cadastro de primeiro aluno
                        </>}
                        width={"80vw"}
                        open={true}
                        footer={null}

                        closable={false}
                    >
                        <Navigate to={'/'} />
                        <NovoAlunoDoResponsavel
                            depoisDeFinalizar={(aluno, viagem) => {
                                setAlunoSelecionado(aluno);
                                if(viagem.senha){
                                    window.location.href = "/area-restrita/viagens/inscricao?s=" + viagem.senha
                                } else {
                                    window.location.reload();
                                }
                            }}
                        />
                    </Modal>
            } */}

            {props.children}

        </ParametrosDaSessaoARContext.Provider>

    </React.Fragment>
}